import React from 'react';
import { UserCard } from './ProfileCards';
import { FormattedBody } from '../ui/formatted-body';
import ProfilePostsSection from './ProfilePostsSection';

const Section = ({ children }) => (
    <div className="mb-2 max-w-full overflow-x-clip rounded-lg border border-border bg-secondary p-4 shadow-sm sm:p-6">
        {children}
    </div>
);

/**
 * Organization about, staff, and posts.
 * @param {Object} props
 * @param {Object} props.organization
 * @param {number} props.userId
 * @param {Object} props.viewerUser
 * @returns {JSX.Element}
 */
const OrganizationProfileInfo = ({ organization, userId, viewerUser }) => {
    return (
        <>
            {organization.denomination ? (
                <Section>
                    <div className="mx-auto max-w-3xl">
                        <h2 className="mb-2 text-xl font-bold text-text-primary">Denomination</h2>
                        <p className="text-text-secondary">{organization.denomination}</p>
                    </div>
                </Section>
            ) : null}

            {/* About Section */}
            {organization.bio && (
                <Section>
                    <div className="max-w-3xl mx-auto">
                        <h2 className="text-xl font-bold mb-4 text-text-primary">About</h2>
                        <FormattedBody as="p" className="text-text-secondary">{organization.bio}</FormattedBody>
                    </div>
                </Section>
            )}

            {/* Staff Members Section */}
            <Section>
                <div className="max-w-3xl mx-auto">
                    <h2 className="text-xl font-bold mb-4 text-text-primary">Staff Members</h2>
                    {organization.affiliations && organization.affiliations.length > 0 ? (
                        <div className="space-y-3">
                            {organization.affiliations.filter((aff) => aff.status === 'active').map((affiliation) => (
                                <UserCard 
                                    key={affiliation.id} 
                                    affiliation={affiliation} 
                                />
                            ))}
                        </div>
                    ) : (
                        <p className="text-text-muted">No staff members found.</p>
                    )}
                </div>
            </Section>

            <Section>
                <div className="mx-auto max-w-3xl">
                    <h2 className="mb-4 text-xl font-bold text-text-primary">Posts</h2>
                    <ProfilePostsSection
                        viewerId={userId}
                        viewerUser={viewerUser}
                        authorId={organization.id}
                        isOrg
                    />
                </div>
            </Section>
        </>
    );
};

export default OrganizationProfileInfo;
